<template>
	<router-view v-if="router"></router-view>
</template>

<script>
import { modules } from '@/utils/api'
import constant from '@/utils/constant'
export default {
	data() {
		return {
			router: false,
			pathUrl: [
				{
					id: constant.MODULES_OBJ.plateformId,
					url: '/yingyong/platform',
					pathName: 'platform',
				},
				{
					id: constant.MODULES_OBJ.toolId,
					url: '/yingyong/tool',
					pathName: 'tool',
				},
				{
					id: constant.MODULES_OBJ.serve,
					url: '/yingyong/serve',
					pathName: 'serve',
				},
				{
					id: constant.MODULES_OBJ.purchased,
					url: '/yingyong/purchased',
					pathName: 'purchased',
				},
				{
					id: constant.MODULES_OBJ.cloud,
					url: '/yingyong/cloudservices',
					pathName: 'cloudservices',
				},
				{
					id: constant.MODULES_OBJ.openapi,
					url: '/yingyong/openapi',
					pathName: 'openapi',
				},
			],
		}
	},
	mounted() {
		this.reqmodules()
	},
	methods: {
		//模块列表,解决页面直接跳转，应用市场页面空白
		reqmodules() {
			modules().then((res) => {
				res.forEach((item) => {
					this.pathUrl.forEach((pathObj, idx) => {
						if (pathObj.id == item.id) {
							Object.assign(pathObj, item)
							this.$set(this.pathUrl, idx, pathObj)
						}
					})
				})
				let obj = this.pathUrl.filter((item) => item.pathName === this.$route.name)
				sessionStorage.setItem('projectInfo', JSON.stringify(obj[0]))
				this.router = true
			})
		},
	},
}
</script>

<style></style>
